import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Select, Modal, Tag, Popconfirm, Button } from "antd";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { getSubdomain } from "app/utils/generic.helper";
import { DeleteOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
const { Option } = Select;


const HotelEmailConfigList = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const [userDetails] = useRecoilState<any>(userInfo);
  const domain = getSubdomain();



  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
  }, [tableData]);


  const fetchData = async () => {
    try {
      const payload = {
        type: "Hotel",
        domain: domain,
        userDetails: {
          email: userDetails?.email,
          currentWorkspace: userDetails?.currentWorkspace?.name,
          workspaceId: userDetails?.currentWorkspace?.id,
        },
      };

      const response = await axios.post(
        "https://stage-apiplatform.finkraftai.com/api/misc/followup/config/list",
        // "http://192.168.0.13:7002/api/misc/followup/config/list",
        payload
      );

      const dataList = Array.isArray(response.data?.data) ? response.data.data : response.data;

      if (Array.isArray(dataList)) {
        setTableData(dataList);
      }
    } catch {
      // ignore
    }
  };




  const handleStatusChange = (newStatus: string, data: any) => {
    Modal.confirm({
      title: `Are you sure you want to change status to "${newStatus}"?`,
      onOk: async () => {
        try {
          const payload = {
            _id: data._id,
            status: newStatus,
          };


          const response = await axios.post(
            "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateStatus",
            payload
          );

          const updatedData = tableData.map(item =>
            item._id === data._id ? { ...item, status: newStatus } : item
          );


          setTableData(updatedData);

          // Force refresh all rows
          gridRef.current?.api?.refreshCells({ force: true });
        } catch (error) {
          Modal.error({
            title: "Update Failed",
            content: "There was an error updating the status. Please try again.",
          });
        }
      },
    });
  };



  const StatusCellRenderer = (props: any) => {
    const { data } = props;

    return (
      <Select
        value={data.status}
        onChange={(value) => handleStatusChange(value, data)}
        style={{ width: "120px" }}
      >
        <Option value="PENDING">PENDING</Option>
        <Option value="RUNNING">RUNNING</Option>
      </Select>
    );
  };


  // ActionCellRenderer component
  const ActionCellRenderer = (props: any) => {
    const { data } = props;

    const handleEdit = () => {
      if (!data._id) return;
      navigate("/email_followup_config", {
        state: { action: "edit", data: data },
      });
    };

    const handleDelete = async () => {

      if (!data._id) {
        return;
      }

      try {
        const response = await axios.post(
          'https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/removeConfig',
          { _id: data._id }
        );

        setTableData(prev => prev.filter(item => item._id !== data._id));

        alert('Deleted successfully!');
      } catch (error) {
        alert('Failed to delete. Please try again.');
      }
    };

    return (

      <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>

        <Button
          size="small"
          icon={<EditOutlined />}
          onClick={handleEdit}
          style={{
            backgroundColor: "#0a8394",
            borderColor: "#0a8394",
            color: "#fff",
          }}
        >
          Edit
        </Button>
        <Popconfirm
          title="Are you sure you want to delete this config?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button
            size="small"
            icon={<DeleteOutlined />}
            danger
            style={{
              background: "transparent",
              border: "1px solid #ff4d4f",
            }}
          >
            Delete
          </Button>
        </Popconfirm>
      </div>
    );
  };


  // Column definitions
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Config Name",
        field: "name",
        minWidth: 750,
        cellStyle: { fontWeight: "500" },
      },
      {
        headerName: "Status",
        field: "status",
        minWidth: 300,
        cellRenderer: StatusCellRenderer,
        cellStyle: { fontWeight: "500", textAlign: "center" },
        hide:true
      },
      {
        headerName: "Action",
        field: "action",
        minWidth: 600,
        cellRenderer: ActionCellRenderer,
        cellStyle: { fontWeight: "500", textAlign: "center" },
      }
    ],
    []
  );

  return (
    <>
      <PageHeader title="Hotel Email Configurations List" />
      <AgTableClient
        ref={gridRef}
        //@ts-ignore       
        rowData={tableData}
        columnDefs={columnDefs}
        groupPanel
        enablePDFViewer
        pdfDataKey="S3 Link"
        defaultPivot={[""]}
        getRowId={(params: any) => params.data._id}
      // showExport
      />
    </>
  );
};

export default HotelEmailConfigList;